module.exports = __webpack_public_path__ + "static/media/related-parties-list-icon.9e9c915e.svg";